import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class ForceSyncToPayrollArgs extends ActionArgs {
  @Field(() => [ID])
  ticketIds: string[]
}
